export const MODAL_HEADER_VARIANT = {
  BLUE: "header-blue",
  RED: "header-red",
  ORANGE: "header-orange",
  GREEN: "header-green",
}
